import { useEffect, useState } from 'react';
import { TimeDisplayValuesType } from '../new-lib/types/common';

const useCountdownTimer = (date: string) => {
  const targetDate = new Date(date).getTime();

  const generateTimeDisplay = (): TimeDisplayValuesType => {
    const rightJustNow = new Date().getTime();
    const runway = targetDate - rightJustNow;

    if (isNaN(targetDate)) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        hasEnded: true
      };
    }

    const days = Math.floor(runway / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (runway % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((runway % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((runway % (1000 * 60)) / 1000);

    const stateObj = {
      days: days <= 0 ? 0 : days,
      hours: hours <= 0 ? 0 : hours,
      minutes: minutes <= 0 ? 0 : minutes,
      seconds: seconds <= 0 ? 0 : seconds,
      hasEnded: targetDate <= rightJustNow
    };

    return stateObj;
  };

  const getDisplayValue = (displayValue?: number) => {
    if (displayValue !== undefined)
      return displayValue < 10 ? '0' + displayValue : displayValue?.toString();
  };

  const [timeDisplay, setTimeDisplay] = useState<TimeDisplayValuesType>();

  useEffect(() => {
    setTimeDisplay(generateTimeDisplay);
    const timerInterval = setInterval(
      () => setTimeDisplay(generateTimeDisplay),
      1000
    );

    return () => clearInterval(timerInterval);
  }, []);

  return {
    countdownTime: {
      days: getDisplayValue(timeDisplay?.days),
      hours: getDisplayValue(timeDisplay?.hours),
      minutes: getDisplayValue(timeDisplay?.minutes),
      seconds: getDisplayValue(timeDisplay?.seconds),
      hasEnded: timeDisplay?.hasEnded
    }
  };
};

export default useCountdownTimer;
